import { useState } from 'react'
import type { FormEvent } from 'react'
import { useAuth } from '../core/auth'

/** 로그인/가입 모달. 엑셀 기능은 비로그인 무료 — AI 사용에만 필요하다. */
export default function AuthDialog({ onClose }: { onClose: () => void }) {
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [invite, setInvite] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const login = useAuth((s) => s.login)
  const register = useAuth((s) => s.register)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (busy) return
    setBusy(true)
    setError('')
    const err = mode === 'login' ? await login(username, password) : await register(username, password, invite)
    setBusy(false)
    if (err) setError(err)
    else onClose()
  }

  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal auth-modal">
        <div className="modal-head">
          <b>{mode === 'login' ? '로그인' : '회원가입'}</b>
          <button className="modal-x" onClick={onClose} aria-label="닫기">
            ✕
          </button>
        </div>
        <form onSubmit={submit} className="auth-form">
          <p className="auth-note">
            엑셀 기능은 로그인 없이 무료입니다.
            <br />
            AI 어시스턴트는 로그인 후 관리자에게 <b>캐시</b>를 받으면 사용할 수 있어요.
          </p>
          <label>
            아이디
            <input
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              placeholder="2~32자"
            />
          </label>
          <label>
            비밀번호
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              placeholder="6자 이상"
            />
          </label>
          {mode === 'register' && (
            <label>
              초대코드
              <input
                value={invite}
                onChange={(e) => setInvite(e.target.value)}
                placeholder="관리자에게 받은 코드"
                autoComplete="off"
              />
            </label>
          )}
          {error && <div className="auth-error">{error}</div>}
          <button
            className="auth-submit"
            type="submit"
            disabled={busy || !username.trim() || !password || (mode === 'register' && !invite.trim())}
          >
            {busy ? '처리 중…' : mode === 'login' ? '로그인' : '가입하기'}
          </button>
          <button
            type="button"
            className="auth-switch"
            onClick={() => {
              setMode((m) => (m === 'login' ? 'register' : 'login'))
              setError('')
            }}
          >
            {mode === 'login' ? '계정이 없나요? 회원가입' : '이미 계정이 있나요? 로그인'}
          </button>
        </form>
      </div>
    </div>
  )
}
